import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

const typography = {
  SansSerif: 'mr-eaves-modern, sans-serif',
  Serif: 'kepler-std, serif',
  SerifHead: 'kepler-std, serif',
  // Display: 'cursive',
};

injectGlobal(`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${typography.SansSerif};
    color: black;
  }

  ${
    typography.SansSerif &&
    `
      .text-sans-serif {
        font-family: ${typography.SansSerif}
      }
    `
  }

  ${
    typography.Serif &&
    `
      .text-serif {
        font-family: ${typography.Serif}
      }
    `
  }

  ${
    typography.SerifHead &&
    `
      .text-serif-head {
        font-family: ${typography.SerifHead}
      }
    `
  }

  ${
    typography.Display &&
    `
      .text-display {
        font-family: ${typography.Display}
      }
    `
  }

  a {
    color: ${colors.color1};
    &:hover {
      text-decoration: none;
      color: ${colors.color1Darkest};
    }
  }
`);

export default typography;



// WEBPACK FOOTER //
// ./src/styles/typography.js